<script setup lang="ts">
import { ref } from "vue";
import { RouterLink } from "vue-router";
const primary = ref("rgb(var(--v-theme-primary))");
const secondary = ref("rgb(var(--v-theme-secondary))");
</script>
<template>
  <div class="logo">
    <NuxtLink to="/" class="logo-link" aria-label="Onibi dashboard">
      <img src="~/public/images/logos/logo.png" alt="Logo" />
      <div class="text-container">
        <div class="main-text">OnibiPortal</div>
        <div class="sub-text">For Dev Stuff</div>
      </div>
    </NuxtLink>
  </div>
</template>

<style scoped>
.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo img {
  width: 50px;
  height: 50px;
}

.text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10px;
}

.main-text {
  color: rgb(var(--v-theme-primary));
  margin: 0;
  font-size: 24px;
  line-height: 28px;
  text-decoration: none;
  text-align: left;
  font-weight: 900;
}

.sub-text {
  color: rgb(var(--v-theme-secondary));
  margin: 0;
  text-decoration: none;
  text-align: left;
  font-size: 12px;
  font-weight: 500;
}
</style>
